import exportChart from './export-chart.vue';
import { Event } from '../../event-bus';

export default {
    components: {
        exportChart,
    },

    computed: {
        loading() {
            return this.onLoading('fetch-chart-data');
        },
    },

    watch: {
        loading(newValue) {
            if (newValue) {
                this.$emit('start-loading');
            } else {
                this.$emit('end-loading');
            }
        },
    },

    mounted() {
        this.$on('start-loading', () => {
            this.$refs.chart.showLoading({ text: 'loading...' });
        });

        this.$on('end-loading', () => {
            this.$refs.chart.hideLoading();
        });

        Event.$on('window-resized', () => {
            this.$refs.chart.resize();
        });
    },

    methods: {
        displayShortName(name) {
            if (!name) {
                return;
            }

            if (name.length > 13) {
                return name.substr(0, 13).trim() + '..';
            }

            return name;
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/item/mixins.js